const loadingPcoWorkflows = (state) => {
    return state.carregando
}

export {
    loadingPcoWorkflows
}